import { ICONES_PAGINACAO } from "@/frontend/utils/icones.jsx";

function SemRegistros() {
  return (
    <div className="sem-registros">
      {ICONES_PAGINACAO.SEM_REGISTROS} Sem registros
    </div>
  );
}

export default SemRegistros;
